{
    "WHATSAPP_TEMPLATES": {
        "MODAL": {
            "TITLE": "WhatsApp Veidnes",
            "SUBTITLE": "Izvēlieties WhatsApp veidni, kuru vēlaties nosūtīt",
            "TEMPLATE_SELECTED_SUBTITLE": "Apstrādāt {templateName}"
        },
        "PICKER": {
            "SEARCH_PLACEHOLDER": "Meklēt Veidnes",
            "NO_TEMPLATES_FOUND": "Veidnes nav atrastas",
            "LABELS": {
                "LANGUAGE": "Valoda",
                "TEMPLATE_BODY": "Veidnes Pamatteksts",
                "CATEGORY": "Kategorija"
            }
        },
        "PARSER": {
            "VARIABLES_LABEL": "Mainīgie",
            "VARIABLE_PLACEHOLDER": "Ievadiet {variable} vērtību",
            "GO_BACK_LABEL": "Atgriezties",
            "SEND_MESSAGE_LABEL": "Sūtīt Ziņojumu",
            "FORM_ERROR_MESSAGE": "Lūdzu, pirms nosūtīšanas aizpildiet visus mainīgos"
        }
    }
}
